module.exports = __webpack_public_path__ + "img/advantage_5_bg.154af8ec.png";